export default __webpack_public_path__ + "static/media/under.835ac1d6.jpg";